import { render, staticRenderFns } from "./market-notifications.vue?vue&type=template&id=a2253484&scoped=true"
import script from "./market-notifications.vue?vue&type=script&lang=js"
export * from "./market-notifications.vue?vue&type=script&lang=js"
import style0 from "./market-notifications.vue?vue&type=style&index=0&id=a2253484&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2253484",
  null
  
)

export default component.exports